import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TranslateStage } from '../translate-stage';
import { TranslateServerSideModel } from '../../models/translate-server-side-model';
import { TranslateStep } from '../../types';
import { OriginalInputModel } from '@/domains/translate-bot/models/original-input-model';
import { ASYNC_THRESHOLD } from '../../constants';
import { TranslationTaskNameGetter } from '../task-name-manager';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

@injectable()
export class TranslateStageWaiting implements TranslateStage {
    constructor(
        @inject(OriginalInputModel)
        private _originalInputModel: OriginalInputModel,
        @inject(TranslationTaskNameGetter)
        private _taskNameGetter: TranslationTaskNameGetter,
        @inject(CurrentTaskService)
        private _currentTaskService: CurrentTaskService,
    ) {}

    isPreviousStage(): boolean {
        return false;
    }

    isCurrentStage(model: TranslateServerSideModel): boolean {
        return model.modelData.currentStep === TranslateStep.StepWaiting;
    }

    onLeave(): Promise<void> {
        console.info('TranslateStageWaiting beforeLeave');
        return Promise.resolve();
    }

    isNextStage(model: TranslateServerSideModel): boolean {
        return model.modelData.currentStep === TranslateStep.StepInitial
            && this.isAsyncThreshold;
    }

    onEnter(model: TranslateServerSideModel): void {
        console.log('TranslateStageWaiting onEnter');
        this._getTaskName();
        model.update(states => {
            return {
                ...states,
                currentStep: TranslateStep.StepWaiting,
            };
        });
    }


    /**
     * 获取任务名称
     * @returns 任务名称
     */
    private _getTaskName(): Promise<string> {
        return this._taskNameGetter.getTaskName(this._currentTaskService.taskId);
    }

    /**
     * 是否达到异步翻译任务阈值
     */
    private get isAsyncThreshold() {
        return this._originalInputModel.modelData.input.length > ASYNC_THRESHOLD;
    }
}
